var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHrms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-92"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.89,322.19a.48.48,0,0,1-.17-.37c-.13-2.66-1.72-28.76-17.71-46.64-13.52-15.13.35-4.33,6.37.53a.56.56,0,0,0,.83-.71c-4.24-7.18-14.89-26.13-11.2-29.82,3.49-3.49,10.7,13.82,13.91,22.22a.56.56,0,0,0,1.08-.26c-.93-8.88-2.28-27.47,2.73-26.82s3.57,25.21,2.59,37.22a.56.56,0,0,0,1.09.21c2.24-7.39,6.49-18.32,11.49-15.43,7.4,4.29-10.89,19.34-9.74,35.67C388.28,314,388.57,324.5,385.89,322.19Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.49,324.61c.06,0,.13-.25.1-.43C392.1,302.06,415.52,286,432,278c3.66-1.77,7.46-3.6,10.58-6.32-6.09.41-12.18,3-18,4.92-.77.26-1.18-.54-.51-1,7.46-5.18,28.23-24.24,22.25-29.79-2.71-2.51-17.62,17.38-21.13,20.95-.57.57-1.48.06-1.08-.61,4.63-7.75,6.16-32.18,1.48-31.89-2,.13-2.74,11.58-3.79,16.24-1.95,8.72-5.61,16.92-9.44,25-.34.71-1.52.59-1.34-.12,1.33-5.34,1.83-21-4.75-19.88-4.77.82-4,10-4.05,15-.08,8.78-.81,17.77-4.59,25.59C395,301.36,391.8,325.05,395.49,324.61Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.19,327.06a.34.34,0,0,0,.11-.25c.09-1.79,1.16-19.31,11.89-31.31,9.07-10.15-.23-2.91-4.27.36a.37.37,0,0,1-.56-.48c2.85-4.82,10-17.54,7.51-20s-7.17,9.28-9.33,14.92a.37.37,0,0,1-.72-.17c.62-6,1.52-18.45-1.84-18s-2.4,16.92-1.74,25a.37.37,0,0,1-.73.14c-1.5-5-4.36-12.3-7.71-10.36-5,2.88,7.31,13,6.54,23.94C388.59,321.56,388.39,328.61,390.19,327.06Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.28,376.31c5.52-20.6,9.16-49.61,9.16-56.75H370.23c0,7.14,3.64,36.15,9.17,56.75a8.65,8.65,0,0,0,8.37,6.41h6.13A8.67,8.67,0,0,0,402.28,376.31Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.25,333.19c.31-2.5.56-4.79.75-6.79H370.67c.19,2,.44,4.29.75,6.79Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.2,
    y: 190.84,
    width: 47.75,
    height: 47.75,
    transform: "translate(168.16 429.44) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.81,
    y: 195.45,
    width: 38.54,
    height: 38.54,
    rx: 4.6,
    transform: "translate(168.16 429.44) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,195.45a2.9,2.9,0,0,1-2.83,2.3H79a2.9,2.9,0,0,1-2.83-2.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.2,
    y: 238.6,
    width: 47.75,
    height: 47.75,
    transform: "translate(168.16 524.95) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.81,
    y: 243.21,
    width: 38.54,
    height: 38.54,
    rx: 4.6,
    transform: "translate(168.16 524.95) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,243.21a2.9,2.9,0,0,1-2.83,2.3H79a2.9,2.9,0,0,1-2.83-2.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.2,
    y: 286.35,
    width: 47.75,
    height: 47.75,
    transform: "translate(168.16 620.46) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.81,
    y: 290.96,
    width: 38.54,
    height: 38.54,
    rx: 4.6,
    transform: "translate(168.16 620.46) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,291a2.9,2.9,0,0,1-2.83,2.3H79a2.9,2.9,0,0,1-2.83-2.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.2,
    y: 334.1,
    width: 47.75,
    height: 47.75,
    transform: "translate(168.16 715.96) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.81,
    y: 338.71,
    width: 38.54,
    height: 38.54,
    rx: 4.6,
    transform: "translate(168.16 715.96) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,338.71A2.91,2.91,0,0,1,89.2,341H79a2.91,2.91,0,0,1-2.83-2.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.35,
    y: 190.84,
    width: 5.85,
    height: 191.02,
    transform: "translate(114.56 572.7) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.22,
    y: 91.76,
    width: 46.47,
    height: 46.47,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.69,
    y: 91.76,
    width: 2.2,
    height: 46.47,
    transform: "translate(879.57 229.99) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.42,
    y: 95.97,
    width: 38.06,
    height: 38.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.16,
    y: 99.71,
    width: 30.58,
    height: 30.58,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.8,
    y: 145.65,
    width: 29.68,
    height: 49.24,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.48,
    y: 145.65,
    width: 1.4,
    height: 49.24,
    transform: "translate(880.37 340.54) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.48,
    y: 150.11,
    width: 24.31,
    height: 40.33,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.87,
    y: 154.07,
    width: 19.53,
    height: 32.4,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 359.32,
    cy: 104.11,
    rx: 20.84,
    ry: 13.86,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 360.74,
    cy: 104.11,
    rx: 20.84,
    ry: 13.86,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 360.74,
    cy: 104.11,
    rx: 16.29,
    ry: 10.83,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-92"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-92",
    cx: 250,
    cy: 415.69,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.54,410.65V414a3.14,3.14,0,0,0,3.13,3.14H302.6a2.89,2.89,0,0,0,2.88-2.89V411a2.88,2.88,0,0,0-2.88-2.89H272.77a5.46,5.46,0,0,1-5.38-6.39l10.46-60.44H209.74l-29.17,64.54A11.71,11.71,0,0,0,179.54,410.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.84,408a11.76,11.76,0,0,0-.31,2.64V414a3.15,3.15,0,0,0,3.14,3.14H302.6a2.89,2.89,0,0,0,2.89-2.89V411a2.89,2.89,0,0,0-2.89-2.89H272.77a5.13,5.13,0,0,1-1.12-.12Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.72,405.84l29.16-64.54h3.86l-29.17,64.54a11.71,11.71,0,0,0-1,4.81V414a3.14,3.14,0,0,0,3.13,3.14h-3.85a3.14,3.14,0,0,1-3.14-3.14v-3.34A11.56,11.56,0,0,1,176.72,405.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.72,405.84l29.16-64.54h3.86l-29.17,64.54a11.71,11.71,0,0,0-1,4.81V414a3.14,3.14,0,0,0,3.13,3.14h-3.85a3.14,3.14,0,0,1-3.14-3.14v-3.34A11.56,11.56,0,0,1,176.72,405.84Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "209.74 341.3 277.85 341.3 275.18 356.72 202.77 356.72 209.74 341.3",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.39,348.07H396a9.58,9.58,0,0,0,9.7-10.62l-18.38-210a11.82,11.82,0,0,0-11.55-10.62H85.15a9.58,9.58,0,0,0-9.69,10.62l18.37,210A11.82,11.82,0,0,0,105.39,348.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.72,314.74l2,22.71a9.58,9.58,0,0,1-9.7,10.62H105.39a11.82,11.82,0,0,1-11.56-10.62l-2-22.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.1,308.33H392.34a5.21,5.21,0,0,0,5.26-5.77L382.41,129a6.41,6.41,0,0,0-6.26-5.76H85.91A5.2,5.2,0,0,0,80.65,129L95.84,302.56A6.41,6.41,0,0,0,102.1,308.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.1,308.33H392.34a5.21,5.21,0,0,0,5.26-5.77L382.41,129a6.41,6.41,0,0,0-6.26-5.76H85.91A5.2,5.2,0,0,0,80.65,129L95.84,302.56A6.41,6.41,0,0,0,102.1,308.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.73,116.82h6.42a9.58,9.58,0,0,0-9.69,10.62l18.37,210a11.82,11.82,0,0,0,11.56,10.62H99a11.81,11.81,0,0,1-11.55-10.62L69,127.44A9.58,9.58,0,0,1,78.73,116.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.73,116.82h6.42a9.58,9.58,0,0,0-9.69,10.62l18.37,210a11.82,11.82,0,0,0,11.56,10.62H99a11.81,11.81,0,0,1-11.55-10.62L69,127.44A9.58,9.58,0,0,1,78.73,116.82Z",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "89.81 123.23 100.97 123.23 140.31 308.32 129.15 308.32 89.81 123.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.59 308.32 112.25 123.23 154.19 123.23 193.54 308.32 151.59 308.32",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M403.72,314.74l2,22.71a9.58,9.58,0,0,1-9.7,10.62H105.39a11.82,11.82,0,0,1-11.56-10.62l-2-22.71Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.73,117h6.42a9.58,9.58,0,0,0-9.69,10.62l18.37,210a11.82,11.82,0,0,0,11.56,10.62H99a11.81,11.81,0,0,1-11.55-10.62L69,127.64A9.58,9.58,0,0,1,78.73,117Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.83,393.48c0,.06.28.36-.82.43-2.74.18-7.55.12-9.3-2.19-2.48-3.31,3.47-3.15,3-5s-7-.16-8.16-2.78,3.48-2.23,3.3-3.59-5.12.53-6.65-2.24,2.7-1.38,2-2.53-5.93-5.87-3.71-7,7.18,3.81,8.85,4.31,2.2-4.49,4.36-2.88.49,9.16,3,10c1.9.65.94-2,3.3-2C117.23,378.11,118,388.61,114.83,393.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.83,393.48c0,.06.28.36-.82.43-2.74.18-7.55.12-9.3-2.19-2.48-3.31,3.47-3.15,3-5s-7-.16-8.16-2.78,3.48-2.23,3.3-3.59-5.12.53-6.65-2.24,2.7-1.38,2-2.53-5.93-5.87-3.71-7,7.18,3.81,8.85,4.31,2.2-4.49,4.36-2.88.49,9.16,3,10c1.9.65.94-2,3.3-2C117.23,378.11,118,388.61,114.83,393.48Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.13,396.42c2.11.14,5.8-1.66,7.3-3.51s-2.57-.84-2.09-2.34,5.41-.16,6.42-2.3-2.6-1.79-2.41-2.89,3.9-.72,5.2-3-2-1.11-1.48-2,4.83-4.79,3.15-5.7-5.7,3.11-7,3.52-1.48-2.5-3.22-1.18-.75,7.43-2.76,8.14c-1.49.53-.75-2.22-2.47-1.59C113.75,384.65,115.28,396.37,116.13,396.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.13,396.42c2.11.14,5.8-1.66,7.3-3.51s-2.57-.84-2.09-2.34,5.41-.16,6.42-2.3-2.6-1.79-2.41-2.89,3.9-.72,5.2-3-2-1.11-1.48-2,4.83-4.79,3.15-5.7-5.7,3.11-7,3.52-1.48-2.5-3.22-1.18-.75,7.43-2.76,8.14c-1.49.53-.75-2.22-2.47-1.59C113.75,384.65,115.28,396.37,116.13,396.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.35,368.78c-.09.13.62.86-1.8.86-6,0-16.47-.83-20.2-6.41-5.33-8,7.66-6.71,6.56-11s-15.21-1.4-17.69-7.59,7.64-4.6,7.3-7.74-11.18.47-14.43-6.13,5.92-2.76,4.52-5.5-12.77-14.34-7.88-16.63,15.54,9.79,19.15,11.18,4.93-10,9.59-6,.8,21.08,6.33,23.44c4.13,1.76,2.09-4.49,7.25-4C118.06,333.84,119.38,358.05,112.35,368.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.35,368.78c-.09.13.62.86-1.8.86-6,0-16.47-.83-20.2-6.41-5.33-8,7.66-6.71,6.56-11s-15.21-1.4-17.69-7.59,7.64-4.6,7.3-7.74-11.18.47-14.43-6.13,5.92-2.76,4.52-5.5-12.77-14.34-7.88-16.63,15.54,9.79,19.15,11.18,4.93-10,9.59-6,.8,21.08,6.33,23.44c4.13,1.76,2.09-4.49,7.25-4C118.06,333.84,119.38,358.05,112.35,368.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.13,375.28c4.89.3,13.45-3.88,16.93-8.15s-6-2-4.85-5.45,12.55-.37,14.91-5.33-6-4.16-5.59-6.72,9.05-1.66,12.06-6.91-4.72-2.57-3.43-4.74,11.22-11.11,7.32-13.24-13.25,7.23-16.28,8.19-3.45-5.81-7.48-2.76-1.73,17.25-6.39,18.91c-3.48,1.23-1.74-5.15-5.74-3.69C113.59,347.93,117.15,375.15,119.13,375.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.13,375.28c4.89.3,13.45-3.88,16.93-8.15s-6-2-4.85-5.45,12.55-.37,14.91-5.33-6-4.16-5.59-6.72,9.05-1.66,12.06-6.91-4.72-2.57-3.43-4.74,11.22-11.11,7.32-13.24-13.25,7.23-16.28,8.19-3.45-5.81-7.48-2.76-1.73,17.25-6.39,18.91c-3.48,1.23-1.74-5.15-5.74-3.69C113.59,347.93,117.15,375.15,119.13,375.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116,390h0a.4.4,0,0,0,.36-.42c-3.25-40.17-25.62-57.37-25.84-57.54a.39.39,0,0,0-.54.08.38.38,0,0,0,.07.54c.23.17,22.31,17.18,25.53,57A.39.39,0,0,0,116,390Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.51,337.83a.37.37,0,0,0,.36-.25.38.38,0,0,0-.22-.5c-.14-.05-3.53-1.27-9.2-.31a.39.39,0,0,0,.13.76,18.85,18.85,0,0,1,8.8.28A.3.3,0,0,0,95.51,337.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.57,342.86a.39.39,0,0,0,.39-.36c.61-12.09-6-21.82-6.07-21.92a.39.39,0,0,0-.54-.1.4.4,0,0,0-.1.54c.07.09,6.53,9.62,5.93,21.44a.39.39,0,0,0,.37.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,353.38a.4.4,0,0,0,.27-.11.39.39,0,0,0,0-.55c-.05-.05-5-5.05-11.92-2.9a.39.39,0,0,0-.26.49.4.4,0,0,0,.49.25c6.43-2,11.09,2.65,11.13,2.7A.39.39,0,0,0,106,353.38Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3,360.66a.37.37,0,0,0,.35-.22,29,29,0,0,0,1.86-14.94.38.38,0,0,0-.43-.34.4.4,0,0,0-.34.43A28.86,28.86,0,0,1,109,360.11a.38.38,0,0,0,.19.51A.32.32,0,0,0,109.3,360.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.21,404.3a.4.4,0,0,0,.39-.36l.93-10.57c2.92-35.15,28.05-58.11,28.31-58.33a.39.39,0,0,0-.52-.58c-.26.23-25.61,23.38-28.56,58.85l-.94,10.57a.39.39,0,0,0,.36.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.34,347.85h.06l.11,0,.13-.05a25.1,25.1,0,0,1,10-1.51.39.39,0,0,0,.42-.36.4.4,0,0,0-.37-.42A26.15,26.15,0,0,0,134.37,347l-.13,0-.07,0a.4.4,0,0,0-.22.42A.39.39,0,0,0,134.34,347.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.73,352.25h0a.38.38,0,0,0,.37-.41c-.51-10.43,5.22-18.76,5.28-18.84a.39.39,0,0,0-.09-.54.39.39,0,0,0-.54.1c-.06.08-6,8.62-5.42,19.32A.38.38,0,0,0,130.73,352.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,358.12a.39.39,0,0,0,.27-.1,10.5,10.5,0,0,1,9.79-2,.4.4,0,0,0,.49-.26.38.38,0,0,0-.26-.48,11.12,11.12,0,0,0-10.55,2.15.38.38,0,0,0,0,.55A.39.39,0,0,0,127,358.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.08,367.86a.47.47,0,0,0,.17,0,.39.39,0,0,0,.18-.52,25.61,25.61,0,0,1-1.55-12.83.4.4,0,0,0-.34-.43.38.38,0,0,0-.43.34,26,26,0,0,0,1.62,13.25A.39.39,0,0,0,122.08,367.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.62,398h.08a.39.39,0,0,0,.3-.46c-2.59-13.84-10.47-19.89-10.55-19.95a.39.39,0,0,0-.54.08.38.38,0,0,0,.08.54c.07.06,7.72,5.94,10.25,19.48A.39.39,0,0,0,115.62,398Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.48,380.52a.39.39,0,0,0,.13-.76,8.45,8.45,0,0,0-4.07-.14.4.4,0,0,0-.32.45.39.39,0,0,0,.45.31,8,8,0,0,1,3.67.11A.35.35,0,0,0,107.48,380.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.23,382.68a.38.38,0,0,0,.38-.37,16.81,16.81,0,0,0-2.65-9.57.39.39,0,0,0-.54-.1.4.4,0,0,0-.1.54,16.39,16.39,0,0,1,2.52,9.09.38.38,0,0,0,.37.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,387.21a.4.4,0,0,0,.27-.11.39.39,0,0,0,0-.55,5.49,5.49,0,0,0-5.36-1.3.38.38,0,0,0-.26.48.39.39,0,0,0,.49.26,4.75,4.75,0,0,1,4.57,1.1A.39.39,0,0,0,112,387.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.42,390.35a.39.39,0,0,0,.35-.22,12.79,12.79,0,0,0,.82-6.56.38.38,0,0,0-.43-.34.39.39,0,0,0-.34.43,12.3,12.3,0,0,1-.75,6.14.38.38,0,0,0,.18.51A.35.35,0,0,0,113.42,390.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.92,398.38a.39.39,0,0,0,.38-.29,42.39,42.39,0,0,1,11-18.84.38.38,0,1,0-.51-.57,43.06,43.06,0,0,0-11.29,19.21.39.39,0,0,0,.27.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.3,384.52a.39.39,0,0,1,.27-.45l.05,0a11.56,11.56,0,0,1,4.55-.68.38.38,0,0,1,.36.41.39.39,0,0,1-.41.36,10.54,10.54,0,0,0-4.23.64l0,0-.08,0h-.08A.39.39,0,0,1,122.3,384.52Zm.19-.41.08,0Zm.12-.05Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.13,386.72h0a.39.39,0,0,0,.37-.4,14.29,14.29,0,0,1,2.23-8,.38.38,0,0,0-.09-.54.39.39,0,0,0-.54.09,14.82,14.82,0,0,0-2.37,8.47A.38.38,0,0,0,121.13,386.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.51,389.26a.38.38,0,0,0,.26-.11,4.26,4.26,0,0,1,4-.8.38.38,0,0,0,.48-.26.38.38,0,0,0-.25-.48,5,5,0,0,0-4.77,1,.39.39,0,0,0,0,.54A.41.41,0,0,0,119.51,389.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.41,393.45a.32.32,0,0,0,.16,0,.39.39,0,0,0,.19-.51,10.77,10.77,0,0,1-.65-5.41.4.4,0,0,0-.34-.43.38.38,0,0,0-.43.34,11.26,11.26,0,0,0,.72,5.83A.37.37,0,0,0,117.41,393.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.8,416.37h12.37a2.51,2.51,0,0,0,2.62-1.6l3.3-17.19H103.88l3.31,17.19A2.5,2.5,0,0,0,109.8,416.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.87,397.52v3.16h2.61l2.71,14.09a2.5,2.5,0,0,0,2.61,1.6h12.38a2.52,2.52,0,0,0,2.61-1.6l2.71-14.09h3v-3.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.87,397.52v3.16h2.61l2.71,14.09a2.5,2.5,0,0,0,2.61,1.6h12.38a2.52,2.52,0,0,0,2.61-1.6l2.71-14.09h3v-3.16Z",
    style: {
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Resume--inject-92"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.81,
    y: 66.53,
    width: 146.82,
    height: 242.06,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.81,
    y: 66.53,
    width: 146.82,
    height: 242.06,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 243.63,
    y: 173.87,
    width: 0.99,
    height: 127.23,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.9,
    y: 237.1,
    width: 45.04,
    height: 2.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.9,
    y: 243.11,
    width: 45.04,
    height: 2.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.9,
    y: 249.11,
    width: 45.04,
    height: 2.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.9,
    y: 255.12,
    width: 45.04,
    height: 2.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.9,
    y: 225.11,
    width: 19.59,
    height: 2.37,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.9,
    y: 237.1,
    width: 22.52,
    height: 2.37,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.9,
    y: 243.11,
    width: 15.29,
    height: 2.37,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.9,
    y: 249.11,
    width: 35.93,
    height: 2.37,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.9,
    y: 255.12,
    width: 27.3,
    height: 2.37,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.56,
    y: 237.69,
    width: 9.52,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.56,
    y: 243.7,
    width: 9.52,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.56,
    y: 249.7,
    width: 9.52,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.56,
    y: 255.71,
    width: 9.52,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.94,226.81l.88.14a4.7,4.7,0,0,0,.51,1.25l-.5.71a.33.33,0,0,0,0,.43l.94.94a.33.33,0,0,0,.43,0l.71-.5a4.63,4.63,0,0,0,1.24.51l.15.88a.32.32,0,0,0,.32.28H257a.34.34,0,0,0,.33-.28l.14-.88a4.7,4.7,0,0,0,1.25-.51l.71.5a.33.33,0,0,0,.43,0l.93-.94a.34.34,0,0,0,0-.43l-.51-.71a4.41,4.41,0,0,0,.52-1.25l.88-.14a.33.33,0,0,0,.28-.33v-1.32a.34.34,0,0,0-.28-.33l-.88-.14a4.41,4.41,0,0,0-.52-1.25l.51-.71a.34.34,0,0,0,0-.43l-.93-.93a.34.34,0,0,0-.43,0l-.71.51a4.41,4.41,0,0,0-1.25-.52l-.14-.88a.34.34,0,0,0-.33-.28h-1.33a.32.32,0,0,0-.32.28l-.15.88a4.35,4.35,0,0,0-1.24.52l-.71-.51a.33.33,0,0,0-.43,0l-.94.93a.33.33,0,0,0,0,.43l.5.71a4.7,4.7,0,0,0-.51,1.25l-.88.14a.34.34,0,0,0-.28.33v1.32A.33.33,0,0,0,250.94,226.81Zm5.38-4.64a3.65,3.65,0,1,1-3.65,3.65A3.66,3.66,0,0,1,256.32,222.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.32,
    cy: 275.95,
    rx: 2.16,
    ry: 2.42,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,284.08v-2a3.07,3.07,0,0,1,2.37-2.87l1,.43.86-.46a3.43,3.43,0,0,1,1.52.77,2.88,2.88,0,0,1,1,2.13v2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.8,
    y: 237.47,
    width: 12.53,
    height: 4.56,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.8,
    y: 242.75,
    width: 12.53,
    height: 3.77,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.91,238.64h-.79v-1.4a.76.76,0,0,0-.76-.76H183a.76.76,0,0,0-.76.76v1.4h-.79v-1.4a1.55,1.55,0,0,1,1.55-1.55h2.39a1.56,1.56,0,0,1,1.55,1.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.05,
    y: 173.99,
    width: 12.53,
    height: 4.56,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.05,
    y: 179.42,
    width: 12.53,
    height: 3.61,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.16,175.15h-.79v-1.39a.76.76,0,0,0-.76-.76h-2.39a.76.76,0,0,0-.76.76v1.39h-.79v-1.39a1.55,1.55,0,0,1,1.55-1.55h2.39a1.54,1.54,0,0,1,1.55,1.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.38,177.51l-2.15,1.32L184.68,181a1.09,1.09,0,0,1-1.05,0l-3.55-2.18-2.15-1.32a.34.34,0,0,1,0-.63l5.7-2.86a1.14,1.14,0,0,1,1.05,0l5.7,2.86A.34.34,0,0,1,190.38,177.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.23,179.7V185h0a15.65,15.65,0,0,1-8.15,0h0V179.7l3.55,2.18a1.09,1.09,0,0,0,1.05,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.65,
    y: 177.36,
    width: 0.39,
    height: 6.7,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.18,183.61a.71.71,0,1,0,.71-.7A.7.7,0,0,0,189.18,183.61Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.9,
    y: 280.46,
    width: 19.59,
    height: 2.37,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.9,
    y: 179.23,
    width: 19.59,
    height: 2.37,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.49,
    y: 288.72,
    width: 56.44,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.49,
    y: 293.94,
    width: 56.44,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.49,
    y: 299.17,
    width: 11.41,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.76,
    y: 195.69,
    width: 37.81,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.76,
    y: 200.91,
    width: 20.41,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.76,
    y: 213.93,
    width: 37.81,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.76,
    y: 219.16,
    width: 20.41,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.76,
    y: 260.16,
    width: 37.81,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.76,
    y: 265.39,
    width: 20.41,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.76,
    y: 278.43,
    width: 37.81,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.76,
    y: 283.66,
    width: 20.41,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.32,
    y: 188.3,
    width: 56.44,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.32,
    y: 193.53,
    width: 56.44,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.32,
    y: 198.76,
    width: 11.41,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.87,
    y: 179.23,
    width: 19.59,
    height: 2.37,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.87,
    y: 188.66,
    width: 40.93,
    height: 3,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.16,
    cy: 189.81,
    r: 1.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.87,
    y: 206.9,
    width: 40.93,
    height: 3,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.16,
    cy: 208.06,
    r: 1.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.87,
    y: 225.14,
    width: 40.93,
    height: 3,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.16,
    cy: 226.3,
    r: 1.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.87,
    y: 243.67,
    width: 19.59,
    height: 2.37,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.87,
    y: 253.09,
    width: 40.93,
    height: 3,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.16,
    cy: 254.25,
    r: 1.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.87,
    y: 271.33,
    width: 40.93,
    height: 3,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.16,
    cy: 272.49,
    r: 1.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.87,
    y: 289.57,
    width: 40.93,
    height: 3,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.16,
    cy: 290.73,
    r: 1.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.81,
    y: 78.03,
    width: 146.82,
    height: 87.82,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.81,
    y: 78.03,
    width: 146.82,
    height: 87.82,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.07,146.14a6,6,0,1,1-6-6A6,6,0,0,1,195.07,146.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.08,146.14a6,6,0,1,1-6-6A6,6,0,0,1,211.08,146.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.42,146.14a6,6,0,1,1-6-6A6,6,0,0,1,226.42,146.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.43,146.14a6,6,0,1,1-6-6A6,6,0,0,1,241.43,146.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.48,
    y: 144.94,
    width: 3.11,
    height: 1.22,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.4,149.69h-1.22v-5.23a1.78,1.78,0,0,1,1.77-1.78h.58v1.23H190a.55.55,0,0,0-.55.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.84,
    y: 144.26,
    width: 1.22,
    height: 3.97,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.73,
    y: 144.35,
    width: 1.22,
    height: 3.88,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.42,148.24v-.11c.12-1.7-.18-2.25-.26-2.3a1.74,1.74,0,0,0-1.37.55l-.9-.83a2.94,2.94,0,0,1,2.37-.94c1.08.08,1.55,1.29,1.38,3.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.82,
    y: 142.7,
    width: 1.23,
    height: 1.24,
    rx: 0.32,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.17,147.84a1.75,1.75,0,1,1,1.74-1.75A1.75,1.75,0,0,1,205.17,147.84Zm0-2.88a1.14,1.14,0,1,0,1.13,1.13A1.14,1.14,0,0,0,205.17,145Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.55,149.74h-2.76a2.27,2.27,0,0,1-2.27-2.27v-2.76a2.27,2.27,0,0,1,2.27-2.27h2.76a2.27,2.27,0,0,1,2.26,2.27v2.76A2.27,2.27,0,0,1,206.55,149.74Zm-2.76-6.68a1.65,1.65,0,0,0-1.66,1.65v2.76a1.66,1.66,0,0,0,1.66,1.66h2.76a1.65,1.65,0,0,0,1.65-1.66v-2.76a1.65,1.65,0,0,0-1.65-1.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.1,148.33a.36.36,0,0,1-.27-.12.34.34,0,0,1-.11-.29V144.6a.38.38,0,0,1,.38-.38h1.63a1.11,1.11,0,0,1,.78,1.89,1.18,1.18,0,0,1,.54,1,1.19,1.19,0,0,1-.35.86,1.24,1.24,0,0,1-.86.34c-1.18,0-1.53,0-1.63,0Zm.61-.79h1.14a.45.45,0,0,0,.31-.13.44.44,0,0,0,.13-.31.44.44,0,0,0-.44-.44h-1.37v.87Zm-.23-1.88h1.25a.34.34,0,1,0,0-.67h-1.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.67,147H236.6a.4.4,0,0,1-.39-.38,1.67,1.67,0,0,1,.48-1.16,1.33,1.33,0,0,1,1.06-.31,1.44,1.44,0,0,1,1.05.52,1.4,1.4,0,0,1,.24,1A.38.38,0,0,1,238.67,147Zm-1.61-.76h1.19a.3.3,0,0,0-.06-.11.76.76,0,0,0-.51-.22.52.52,0,0,0-.62.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.68,148.28a1.49,1.49,0,0,1-1.45-1.65v-.38H237v.38c0,.83.53.9.69.9a.71.71,0,0,0,.46-.11v-.27l.76,0v.38a.68.68,0,0,1,0,.14C238.87,147.69,238.67,148.28,237.68,148.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.25,
    y: 108.33,
    width: 53.32,
    height: 2.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.25,
    y: 116.77,
    width: 26.66,
    height: 2.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.25,
    y: 125.8,
    width: 53.32,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.25,
    y: 134.24,
    width: 26.66,
    height: 1.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.5,94.55v7.85h-2.22V99.34h-3v3.06H185V94.55h2.22v3h3v-3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.16,99.9h-4.42a1.4,1.4,0,0,0,1.49,1,1.94,1.94,0,0,0,1.4-.53l1.12,1.17a3.28,3.28,0,0,1-2.59,1c-2.16,0-3.57-1.33-3.57-3.15a3.14,3.14,0,0,1,3.35-3.13,3,3,0,0,1,3.25,3.15C200.19,99.53,200.17,99.73,200.16,99.9Zm-4.46-1.12h2.49a1.19,1.19,0,0,0-1.24-1A1.22,1.22,0,0,0,195.7,98.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.18,94.08h2.13v8.32h-2.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.69,94.08h2.13v8.32h-2.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.82,99.35a3.44,3.44,0,1,1,3.43,3.15A3.18,3.18,0,0,1,207.82,99.35Zm4.71,0a1.29,1.29,0,1,0-2.56,0,1.29,1.29,0,1,0,2.56,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.4,101.33a1.28,1.28,0,1,1,1.28,1.17A1.2,1.2,0,0,1,215.4,101.33Zm0-6.78H218l-.43,5h-1.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.81,
    y: 66.53,
    width: 146.82,
    height: 11.5,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M264.6,137.34a15,15,0,0,0,3.11-12.13H266l-3,2.24h0C263.51,130.35,264.08,133.91,264.6,137.34Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M266.12,166.05s.14-10.56-.06-16.13c0-.73-.05-1.38-.09-1.9-.43-6-3.22-22.25-3.89-26.11a1.7,1.7,0,0,1,.57-1.57,8.29,8.29,0,0,1,2.41-1.39,21.68,21.68,0,0,1,7.21-1.17,54.21,54.21,0,0,1,5.51.18l1.16.1c1.74.17,3.46.39,5.1.65l2.15.35c1.08.19,2.1.38,3.06.58,2.15.43,3.91.84,5,1.12l.1,0a1.64,1.64,0,0,1,.78.45h0a1.62,1.62,0,0,1,.42,1.08l.05,23.4v4.87l0,15.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M283.64,124.39a1.15,1.15,0,1,1-1.11-1.19A1.16,1.16,0,0,1,283.64,124.39Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M284.89,134.23a1.17,1.17,0,0,1-1.2,1.11,1.15,1.15,0,1,1,1.2-1.11Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M285.59,146.12a1.15,1.15,0,1,1-1.11-1.19A1.15,1.15,0,0,1,285.59,146.12Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M285.14,158a1.15,1.15,0,0,1-2.3-.09,1.15,1.15,0,1,1,2.3.09Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M276.55,116.31l1.49,2,2.88,1.91,1.73.43,2.69-.8,1.18-.12.24-.19c-2.69-1.94-2.5-5.13-1.51-7.87l-7.57-7.92C278,107.17,278.07,112.75,276.55,116.31Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M284.59,114.74a10.75,10.75,0,0,1,.66-3.08l-4.63-4.85-2.81-1.3h0c.06,1.19.08,2.51,0,3.85A9.93,9.93,0,0,0,284.59,114.74Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M287.17,93.93s4.74.89,4-2.73c0,0-.28,1.06-5.48.56S287.17,93.93,287.17,93.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M287.17,93.93s4.74.89,4-2.73c0,0-.28,1.06-5.48.56S287.17,93.93,287.17,93.93Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M276.62,98.93c.14,5.26,0,8.34,2.52,11.11,3.85,4.18,10.4,2,11.82-3.19,1.28-4.7.82-12.48-4.24-14.73a7.15,7.15,0,0,0-9.47,3.58A7,7,0,0,0,276.62,98.93Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.77,100.72c0,.43.2.79.48.79s.51-.33.53-.75-.2-.78-.49-.79S284.78,100.3,284.77,100.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.59,100.88c0,.43.2.78.48.79s.51-.33.52-.75-.19-.79-.47-.79S289.6,100.45,289.59,100.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.18,98.67a.5.5,0,0,1-.13,0,.26.26,0,0,1,0-.36,2.5,2.5,0,0,1,2.07-1,.23.23,0,0,1,.22.27.25.25,0,0,1-.27.23h0a2,2,0,0,0-1.63.78A.25.25,0,0,1,283.18,98.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.53,99a.23.23,0,0,1-.19-.15A2,2,0,0,0,290,97.68a.25.25,0,0,1,.08-.5,2.49,2.49,0,0,1,1.75,1.48.23.23,0,0,1-.12.32h0A.23.23,0,0,1,291.53,99Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.31,107a5.06,5.06,0,0,0,.87,0,.16.16,0,0,0,.14-.16h0a.16.16,0,0,0-.16-.14,4,4,0,0,1-3.41-1.36.17.17,0,0,0-.22,0,.15.15,0,0,0,0,.21A4.23,4.23,0,0,0,287.31,107Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.36,100.66a15.27,15.27,0,0,0,1.87,3.61,2.39,2.39,0,0,1-2,.31Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.08,118.34c.14-1.2,2.6-3.26,4-2.7s3.75,4.08,6,4.23,2.79-4,4-3.62a5.61,5.61,0,0,1,2.94,2.56c.42,1,.4,5-.68,4.45,0,0-1.47-2.79-2.4-3.12s-2.65.83-3.57.83-3-1.22-3.9-.82-1.74,3-2.74,2.92C274.27,123,271.9,119.83,272.08,118.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.08,118.34c.14-1.2,2.6-3.26,4-2.7s3.75,4.08,6,4.23,2.79-4,4-3.62a5.61,5.61,0,0,1,2.94,2.56c.42,1,.4,5-.68,4.45,0,0-1.47-2.79-2.4-3.12s-2.65.83-3.57.83-3-1.22-3.9-.82-1.74,3-2.74,2.92C274.27,123,271.9,119.83,272.08,118.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.61,144.86c3.52,1.52,6.34-1.65,6.34-1.65l-5.05-3.81-2.37,3.6Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.9 139.4 292.94 143.2 294.77 140.74 292.65 137.44 287.9 139.4",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.56,123.07c0,2.74,0,5.47.14,8.22.08,2.08.17,4.16.32,6.24s.31,4.17.56,6.29l.09.78,0,.4.1.65a6.92,6.92,0,0,0,.53,1.67,5.22,5.22,0,0,0,1.71,2.07,5,5,0,0,0,2.74.86,5.67,5.67,0,0,0,1.87-.29l17.76-4.78s-1.23-3-1-3.29c-1,.16-10.33.85-16.37,1.28l.08-1.51c0-.7.74-17.67.74-17.67,0-2.29-2.75-5.06-5-5.1A4.2,4.2,0,0,0,261.56,123.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.56,123.07c0,2.74,0,5.47.14,8.22.08,2.08.17,4.16.32,6.24s.31,4.17.56,6.29l.09.78,0,.4.1.65a6.92,6.92,0,0,0,.53,1.67,5.22,5.22,0,0,0,1.71,2.07,5,5,0,0,0,2.74.86,5.67,5.67,0,0,0,1.87-.29l17.76-4.78s-1.23-3-1-3.29c-1,.16-10.33.85-16.37,1.28l.08-1.51c0-.7.74-17.67.74-17.67,0-2.29-2.75-5.06-5-5.1A4.2,4.2,0,0,0,261.56,123.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.4,141.89c.07,0,.09,0,.07,0A.05.05,0,0,0,286.4,141.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.31,103.3s2-1,2-4.8a5,5,0,0,0,2.21-3.82s10-1,8.4-4.53-8.58-4.86-8.58-4.86,2,3.57-4.46,6.35S275.51,103,275.51,103Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.13,95s-2.92-2-1.77-3.07S274.13,95,274.13,95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.9,103.74a5,5,0,0,0,3,2.3c1.7.43,2.51-1.09,2-2.67-.45-1.42-1.88-3.36-3.57-3.1A2.24,2.24,0,0,0,273.9,103.74Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.67,145.2c-3.52,1.53-6.34-1.64-6.34-1.64l5-3.81,2.38,3.59Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.37 139.75 270.33 143.55 268.5 141.08 270.63 137.78 275.37 139.75",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.69,144.17l-.08.78,0,.39-.1.65a7,7,0,0,1-.53,1.68,5.06,5.06,0,0,1-1.72,2.06,4.77,4.77,0,0,1-2.58.86h-.15a5.76,5.76,0,0,1-1.88-.28L281,146.91l-5.14-1.39a.12.12,0,0,0,0-.05,23.18,23.18,0,0,0,1-2.8.84.84,0,0,0,0-.44l.15,0c.39.06,1.26.14,2.43.23,1.62.14,3.8.31,6.1.47l1.05.08,6.08.45c.19,0,1.34.05,1.53.07l-1.9-19.22c0-.06.11-.12.12-.19A5.2,5.2,0,0,1,294,121c.09-.1.19-.19.28-.28l.1,0a3.41,3.41,0,0,1,2.08.59,4.9,4.9,0,0,1,2.14,3.52C299.2,129.61,300.87,142.74,300.69,144.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.69,144.17l-.08.78,0,.39-.1.65a7,7,0,0,1-.53,1.68,5.06,5.06,0,0,1-1.72,2.06,4.77,4.77,0,0,1-2.58.86h-.15a5.76,5.76,0,0,1-1.88-.28L281,146.91l-5.14-1.39a.12.12,0,0,0,0-.05,23.18,23.18,0,0,0,1-2.8.84.84,0,0,0,0-.44l.15,0c.39.06,1.26.14,2.43.23,1.62.14,3.8.31,6.1.47l1.05.08,6.08.45c.19,0,1.34.05,1.53.07l-1.9-19.22c0-.06.11-.12.12-.19A5.2,5.2,0,0,1,294,121c.09-.1.19-.19.28-.28l.1,0a3.41,3.41,0,0,1,2.08.59,4.9,4.9,0,0,1,2.14,3.52C299.2,129.61,300.87,142.74,300.69,144.17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M276.88,142.23l-.08,0A.06.06,0,0,1,276.88,142.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.82,72.35a1.65,1.65,0,1,1-1.65-1.65A1.64,1.64,0,0,1,182.82,72.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.12,72.35a1.64,1.64,0,1,1-1.64-1.65A1.63,1.63,0,0,1,189.12,72.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.43,72.35a1.64,1.64,0,1,1-1.64-1.65A1.63,1.63,0,0,1,195.43,72.35Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "340.72 392.95 339.29 409.59 330.36 409.06 331.02 391.78 340.72 392.95",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.91 386.98 423.76 402.06 415.92 406.6 408.11 391.37 416.91 386.98",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.4,243.28s-20.52,67-24.44,87.54c-3.1,16.22-3.33,66.23-3.33,66.23l11.93,1s2.75-24.14,5.52-44.11a146.48,146.48,0,0,1,4.5-21.46c4.86-15.64,22.56-42.44,28.23-57.76,2-5.29,2.58-30.67,2.58-30.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.64 395.15 327.98 393.84 328 399.92 342.62 400.96 343.64 395.15",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.55,265.43l10.53,8.8c-2.45,4.76-12.85,20.92-16.32,26.54C364.56,287.31,371.55,265.43,371.55,265.43Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.11,243.28s12.76,75.94,19.46,97.1c4.76,15.07,29.34,56.17,29.34,56.17l9.74-5.38s-9.29-22.31-15.74-39.63c-2.2-5.91-4.86-11.24-5.64-14.91-3.32-15.65-2-48-2.92-64-.29-5.07-1.7-28.72-1.7-28.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.64 387.17 422.19 392.62 409.7 399.59 406.84 394.29 419.64 387.17",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.88,409.35a3.39,3.39,0,0,1-2.44-.71.85.85,0,0,1,0-.91,1,1,0,0,1,.62-.49c1.38-.39,4.27,1.41,4.39,1.5a.23.23,0,0,1,.1.22.23.23,0,0,1-.16.17A14.33,14.33,0,0,1,326.88,409.35Zm-1.32-1.75a1.57,1.57,0,0,0-.37,0,.55.55,0,0,0-.39.29c-.14.26-.09.39,0,.46.39.58,2.47.62,4,.44A8.65,8.65,0,0,0,325.56,407.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.38,409.12a.08.08,0,0,1-.08,0c-1-.48-3-2.43-2.8-3.43,0-.24.19-.53.73-.58a1.43,1.43,0,0,1,1.09.37c1.05.95,1.27,3.34,1.28,3.46a.19.19,0,0,1-.09.18A.12.12,0,0,1,329.38,409.12Zm-2-3.62h-.11c-.36,0-.38.18-.39.23-.05.61,1.25,2.13,2.27,2.79a5.29,5.29,0,0,0-1.09-2.74,1,1,0,0,0-.68-.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.26,407.89l9,.11a.75.75,0,0,1,.71.62l1.62,7.9a1.29,1.29,0,0,1-.91,1.55,1.07,1.07,0,0,1-.25,0c-3.26-.1-6.16-.33-10.21-.37-4.78-.05-3.57.58-9.2.6-3.38,0-4-4.14-2.56-4.32,6.58-.82,7.26-2.94,9.8-5.44A2.79,2.79,0,0,1,330.26,407.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.15,408.4c-.91.5-1.94.84-2.45.58a.8.8,0,0,1-.38-.82,1.08,1.08,0,0,1,.33-.74c1.05-1,4.37-.87,4.52-.87a.23.23,0,0,1,.18.15.23.23,0,0,1-.07.23A13.93,13.93,0,0,1,413.15,408.4Zm-1.92-.9a1.66,1.66,0,0,0-.31.23.59.59,0,0,0-.21.45c0,.31.09.39.17.43.59.33,2.44-.68,3.72-1.62A8.59,8.59,0,0,0,411.23,407.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.25,406.94a.09.09,0,0,1-.07,0c-1.08.06-3.68-.68-3.95-1.65-.09-.23-.07-.57.39-.89a1.35,1.35,0,0,1,1.12-.21c1.33.31,2.56,2.34,2.62,2.43a.22.22,0,0,1,0,.21A.15.15,0,0,1,415.25,406.94Zm-3.35-2.21-.1,0c-.3.2-.25.35-.24.4.21.56,2,1.27,3.21,1.34a4.77,4.77,0,0,0-2.15-1.88,1,1,0,0,0-.72.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.49,405.41l8-4.42a.7.7,0,0,1,.89.2l4.86,6.22a1.35,1.35,0,0,1-.13,1.83,1,1,0,0,1-.21.15c-2.91,1.54-5.56,2.79-9.15,4.78-4.23,2.34-2.89,2.29-7.84,5.12-3,1.7-5.32-1.67-4.13-2.56,5.44-4,5.12-6.24,6.28-9.73A3,3,0,0,1,415.49,405.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.11,194.42l-8.75,5.52c-.57.6-18.57-16.87-18.57-16.87s-.62-5.43-.87-6.32l-.61-2.18a4.69,4.69,0,0,1-.12-.75v-.06a3.54,3.54,0,0,0-3.53-3.33h0a3.54,3.54,0,0,0-2,.6l-4.1,2.74a3.55,3.55,0,0,0-1.48,3.72l9.06,7.74s12.49,23.52,18.85,27.22c5.87,3.42,18.54-10.35,18.54-10.35Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.93,187.21c-1.46-1.63-3.05-3.06-6.2-2.83-4.88.34-14.47,11.27-14.47,11.27l8.67,13.81s11.39-10,13.22-14.17A7.19,7.19,0,0,0,355.93,187.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.93,187.21c-1.46-1.63-3.05-3.06-6.2-2.83-4.88.34-14.47,11.27-14.47,11.27l8.67,13.81s11.39-10,13.22-14.17A7.19,7.19,0,0,0,355.93,187.21Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.84,204.92c-.34-5.5-.54-11.51-.54-11.51l4.16,7.87C351.28,202.53,350,203.78,348.84,204.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.44,185.23,362,183.69a8.43,8.43,0,0,0-.94-3.76,21.16,21.16,0,0,0-1.23-2.24l4.18-7.07,3.08-5.18c.61,5.16,2.36,13.91,6.26,17.17Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.84,177.69a21.6,21.6,0,0,1,1.23,2.27c2.06-1.24,4.18-4.66,3.68-7a10.43,10.43,0,0,0-.73-2.3Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.56,187.7l-1.07,57.36-4,.61a75.56,75.56,0,0,1-32.41-2.18h0l-9.6-54.28a4.15,4.15,0,0,1,4-5l38.89-.68A4.14,4.14,0,0,1,394.56,187.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.56,187.7l-1.07,57.36-4,.61a75.56,75.56,0,0,1-32.41-2.18l-9.6-54.28a4.15,4.15,0,0,1,4-5l38.89-.68A4.14,4.14,0,0,1,394.56,187.7Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,217c-11.06-12.77-11.06-22-11.06-22l11.61,3.62Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.26,152.07s-7.27,1-5.75-4.61c0,0,.32,1.67,8.25,1.38S354.26,152.07,354.26,152.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.26,152.07s-7.27,1-5.75-4.61c0,0,.32,1.67,8.25,1.38S354.26,152.07,354.26,152.07Z",
    style: {
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.84,161.27c-1.74,7.4-2.37,11.8-6.8,15.11A9.87,9.87,0,0,1,347.19,169c-.48-6.91,2.44-17.84,10.27-19.81a10,10,0,0,1,12.38,12.06Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.12,161.83c-.1.61-.51,1-.91,1s-.63-.58-.53-1.19.51-1.06.91-1S358.22,161.23,358.12,161.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.22,160.9c-.09.61-.5,1-.9,1s-.63-.58-.54-1.2.51-1,.92-1S351.33,160.29,351.22,160.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.37,161.5a23.5,23.5,0,0,1-3.79,4.81,3.55,3.55,0,0,0,2.81,1Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.17,167.43a5.38,5.38,0,0,1-4.55,1.44.19.19,0,0,0-.12.37h.07a5,5,0,0,0,.77.07,5.59,5.59,0,0,0,4.11-1.63.19.19,0,0,0,0-.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.63,159.9a.25.25,0,0,0,.17,0,.34.34,0,0,0,.16-.47v0a3.49,3.49,0,0,0-2.68-1.92.36.36,0,0,0-.38.32h0a.36.36,0,0,0,.32.39h0a2.78,2.78,0,0,1,2.08,1.49A.33.33,0,0,0,360.63,159.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.67,158.14a.33.33,0,0,0,.3-.15,3,3,0,0,1,2.31-1.35.37.37,0,0,0,.3-.42.39.39,0,0,0-.3-.3h0a3.75,3.75,0,0,0-2.89,1.65.36.36,0,0,0,.08.5h0A.26.26,0,0,0,348.67,158.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.96 187.64 367.66 192.26 366.97 193.26 370.59 230.12 365.76 234.4 360.93 229.45 364.8 193.26 364.04 191.81 361.95 187.64 363.6 185.22 367.88 184.26 369.96 187.64",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.29 180.81 366.28 183.89 359.79 181.07 356.37 184.95 359.72 192.97 366.33 186.09 372.88 193.27 377.58 184.3 374.29 180.81",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.29 180.81 366.28 183.89 359.79 181.07 356.37 184.95 359.72 192.97 366.33 186.09 372.88 193.27 377.58 184.3 374.29 180.81",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.33,201s8.8,12,8.52,16.63c-.45,7.45-16.72,24.76-16.72,24.76l-2,6.51a3.31,3.31,0,0,1-1.57,1.91l-5.23,2.86a3.3,3.3,0,0,1-4.35-1.1l-1.21-1.88a3.3,3.3,0,0,1,.31-4l2-2.3a2.91,2.91,0,0,1,.31-.3l6.7-4.54s5.25-9.34,8.13-16.08A18,18,0,0,0,399,217c0-3.57-6.34-12.8-6.34-12.8Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,184.37c1.79-1.27,6-1,7.9,0,5.15,2.66,13.45,18,13.45,18l-14.94,8.19s-8.92-13.42-9.35-18.74C381.91,189.62,383.22,185.64,385,184.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,184.37c1.79-1.27,6-1,7.9,0,5.15,2.66,13.45,18,13.45,18l-14.94,8.19s-8.92-13.42-9.35-18.74C381.91,189.62,383.22,185.64,385,184.37Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.63,
    y: 178.11,
    width: 2.96,
    height: 1.06,
    transform: "translate(-25.91 51.95) rotate(-9.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.63,
    y: 178.11,
    width: 2.96,
    height: 1.06,
    transform: "translate(-25.91 51.95) rotate(-9.7)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.21,
    y: 176.85,
    width: 9.85,
    height: 1.56,
    transform: "translate(-25.65 52.94) rotate(-9.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.21,
    y: 176.85,
    width: 9.85,
    height: 1.56,
    transform: "translate(-25.65 52.94) rotate(-9.7)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.07,
    y: 174.94,
    width: 12.19,
    height: 1.94,
    transform: "translate(-25.22 54.6) rotate(-9.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.07,
    y: 174.94,
    width: 12.19,
    height: 1.94,
    transform: "translate(-25.22 54.6) rotate(-9.7)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.96,
    y: 173.64,
    width: 1.26,
    height: 2.34,
    transform: "translate(-24.94 55.68) rotate(-9.7)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.33,167.58s-2.88-1.68-2.51-7.66a7.7,7.7,0,0,1-3-6.14s-15-2.47-12.31-7.84S364,139.17,364,139.17s-3.43,5.37,6.16,10.29.94,17.83.94,17.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.93,155s4.63-2.75,3-4.62S373.93,155,373.93,155Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.61,168a6.74,6.74,0,0,1-3.65,3.28c-2.09.76-3.19-1.09-2.65-3.14.5-1.87,2.17-4.49,4.29-4.36S372.54,166.07,371.61,168Z",
    style: {
      fill: "#ce7a63"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrms);
export default __webpack_public_path__ + "static/media/hrms.a9d93fdf00e0976c29851ef9913311ba.svg";
export { ForwardRef as ReactComponent };